var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TemplateItem',{attrs:{"title":_vm.title,"wrap":""}},[_c(_vm.item.component,{tag:"component",attrs:{"module":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }